import { httpClient } from './httpClient';

const base = '/api/centros';

export const listarCentros = () => httpClient.get(base);
export const obtenerCentro = (id) => httpClient.get(`${base}/${id}`);
export const obtenerBrandingActual = () => httpClient.get(`${base}/branding`);
export const crearCentro = (payload) => httpClient.post(base, payload);
export const actualizarCentro = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarCentro = (id) => httpClient.del(`${base}/${id}`);

const centrosService = {
  listar: listarCentros,
  obtener: obtenerCentro,
  obtenerBrandingActual,
  crear: crearCentro,
  actualizar: actualizarCentro,
  eliminar: eliminarCentro,
};

export default centrosService;
